import { render, staticRenderFns } from "./ShippingMethodZoneCodes.vue?vue&type=template&id=3a72c81a&"
import script from "./ShippingMethodZoneCodes.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodZoneCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports